import api from "../../utils/api";
import { rememberSurveyLoginUrl } from "../../utils/auth-redirect";
import {
    RESPONSE_LOADED,
    RESPONSE_ARCHIVED,
    RESPONSE_SAVED,
    SECTION_LOADED,
    NOT_FOUND
} from "../types";



export const update = (id, meta, _private = null, submit = false, authenticated = false) => async (dispatch) => {
    const fields = { meta };
    if (submit) fields.submittedAt = Date.now();
    if (_private !== null) fields.private = _private;

    try {
        
        const url = authenticated ? `/responses/k/${id}` : `/responses/p/k/${id}`;

        let res = await api.post(url, fields);
        const __success = res.data.success;
        
        if (__success) {
            dispatch({
                type: submit ? RESPONSE_SAVED : RESPONSE_ARCHIVED,
                payload: res.data,
            });
            return res.data;
        }
        return res.data;
    
    } catch (err) {
        return {
            success: false,
            message: err?.response?.data?.message || err?.message || "Unable to save the response."
        };
    }
}

export const get = (id) => async (dispatch) => {
    let loginUrl = "";
    let __private = false;
    let __success = false;
    try {
        let res = await api.get(`/responses/p/k/${id}`);
        __private = res?.data?.item?.private;

        if (__private) {
            loginUrl = res.data.item.url;
            rememberSurveyLoginUrl(loginUrl);
            try {
                res = await api.get(`/responses/i/${res.data.item.uuid}`);
            } catch (error) {
                if (error?.response?.status === 401 || error?.status === 401) return;
                throw error;
            }
        } else {
            rememberSurveyLoginUrl(null);
        }
        __success = res?.data?.success;

        if (__success) {
            dispatch({
                type: RESPONSE_LOADED,
                payload: res.data.item,
            });
            return res.data.item;
        }
        return res.data;
    
    } catch (err) {
        dispatch({
            type: NOT_FOUND,
        });
    }
}


export const section = (id) => async (dispatch) => {
    try {
        let res = await api.get(`/template/sections/i/${id}`);
        if (res?.data) {
            dispatch({
                type: SECTION_LOADED,
                payload: res.data,
            });
            return {success: true, ...res.data};
        }
        return {success: false};
    
    } catch (err) {
        dispatch({
            type: NOT_FOUND,
        });
    }
}
